var localEnvironment = require('./env_local')

module.exports = {
  ...localEnvironment,
  userWebComponentsUrl: 'https://use1-user-webcomponents-node-master.awscsuser.kbb.com/build/node.esm.js',
  ico_EdgeApiUrl: 'https://api.kbb.com/ico/v1',
  ico_EdgeApiKey: 'kehj9w5vxkt4t8yugn5zkpey',
  kbbOmnitureSuite: 'kbbbuybk',
  gtmTagId: 'GTM-5C78J6B',
  optimizelySrc: '//cdn.optimizely.com/js/18259871075.js',
  optimizelyKey: 'P99bZyjK66PTr3RQzD2ka',
  optimizelyEnabled: false,
  ico_UseBasicAuth: false,
  ico_Token: 'Q2hhcmxlczptaW5pTWU=',
  kbb_Url: 'https://www.kbb.com',
  ico_directToKBBDealerId: '5ee92276-44b4-47e6-b707-53a1b3344d4b',
  ico_directToKBBDealerIdv2: '725462f5-10f5-4945-ab9b-7f99d5f0d248',
  akamaiStaticPath: 'https://static.kbb.com/icofury/prod/',
  ico_DealerAdminURL: 'https://icodealers.kbb.com',
  canonicalHref: 'https://www.kbb.com/instant-cash-offer',
  funnelWebComponentUrl: 'https://ui.awskbbico.kbb.com/ico-components-funnel/prod/ico-components-funnel/ico-components-funnel.esm.js',
  shouldSubmitOfferFromWebComponent: false,
  recaptchaDisabled: false,
  prefetchYearStart: 0,
  prefetchYearLimit: 1,
  environmentName: 'production',
  optimizely_sdk_key: 'P99bZyjK66PTr3RQzD2ka',
  shiftDigitalUrl: '//tagging.shiftdigitalapps.io',
  fyusionAccountId: 'demo_account',
  fyusionApiUrl: 'https://z48m75hup8.execute-api.us-west-2.amazonaws.com/api/v1',
  fyusionAssetsUrl: 'https://i.fyuse.com/0/sdk/web/ico/assets/',
  fyusionScriptUrl: 'https://i.fyuse.com/0/sdk/web/ico/camera-widget.js',
  // these are only build-time variables, no need to expose to client
  // change requires rebuild
  ...(!process.env.BUILD_STAGE && {
    prefetchMakeLimit: 0,
    prefetchModelLimit: 0
  }),
  kbb_global_nav_api: 'https://use1-globalnav-api-master.awskbbcs.kbb.com/api/navigation/kbb',
  kbb_global_nav_api_key: 'BY9PmOdqei4SlaxhTCbwr7YDFcHxUSvn8KLWl3Oa',
  pixallKbbSrc: 'https://www.kbb.com/pixall/pix-kbb.min.js',
  pixallAtcSrc: 'https://www.autotrader.com/pixall/pix-at.min.js'
}
